module.exports = __webpack_public_path__ + "static/img/previous-step.7e57173b.png";